import ListingStore from "@stores/ListingStore";
import { connectPromotedRecords } from "@helpers/helpers";
import { apiHelper } from "@helpers/apiHelper";
import SfmModalStore from "@stores/SfmModalStore";
import { GetSFMDisplay, isSfmSuccess } from "@helpers/helpers";

const STORE_LIMIT = 50;
const STORE_LIMIT_OFFSET = 0;
class Store extends ListingStore {
  microserviceInput = "";
  dataKey = "MatchingRecords";
  limit = STORE_LIMIT;
  offset = STORE_LIMIT_OFFSET;
  id = "";
  setMicroservice(microservice) {
    this.microserviceInput = microservice;
  }

  async getData() {
    const externalurl = `/api/v1/ControlRoom/GetOutstandingRecords`;
    const activityTag = "GetOutstandingRecords";

    const apiRequest = apiHelper({
      externalurl,
      activityTag,
      filter: {
        enabled: true,
        value: this.filter,
      },
      sort: {
        enabled: true,
        value: this.sort,
      },
      limit: this.limit,
      offset: this.offset,
      extraBody: {
        ExceptionAtHandMatchingRecordId: this.id,
      },
    });

    return apiRequest
      .then((data) => {
        const sfmData = GetSFMDisplay(data.SFM);
        if (!isSfmSuccess(sfmData)) {
          SfmModalStore.open(sfmData);
          return {
            data: [],
            total: 0,
            page: 1,
          };
        } else {
          const matchedRecords = connectPromotedRecords(
            data?.PromotedRecords,
            data?.MatchingRecords
          );
          return {
            data: matchedRecords,
            total: matchedRecords.length, // You might need to adjust this depending on the actual response structure
            page: 1, // Adjust if pagination data is available in the response
          };
        }
      })

      .catch((error) => {
        return;
      });
  }
}

const myStore = new Store();

export default myStore;
